export default function percentOffsetFromElement(
	clickX: number,
	clickY: number,
	selector: string,
) {
	console.log(`in percent offset from element, selector is ${selector}`)
	console.log(
		`in percent offset from element, document.querySelector(selector) is ${document.querySelector(
			selector,
		)}`,
	)

	let elementCoords

	try {
		elementCoords = selector
			? (document.querySelector(selector) as Element).getBoundingClientRect()
			: document.body.getBoundingClientRect()
	} catch (e) {
		console.log(`in percentOffsetFromElement threw error ${e}`)
		elementCoords = document.body.getBoundingClientRect()
	}

	const percentFromTop = (
		(clickY - elementCoords.y - window.scrollY) /
		elementCoords.height
	).toFixed(2)
	const percentFromLeft = (
		(clickX - elementCoords.x - window.scrollX) /
		elementCoords.width
	).toFixed(2)

	return { percentFromTop, percentFromLeft }
}
